/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  DeleteConfigRequestBody,
  DeleteConfigRequestBody$Outbound,
  DeleteConfigRequestBody$outboundSchema,
} from "../components/deleteconfigrequestbody.js";

export type TestDeviceIntegrationConnectionSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type TestDeviceIntegrationConnectionRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  deleteConfigRequestBody: DeleteConfigRequestBody;
};

/** @internal */
export type TestDeviceIntegrationConnectionSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const TestDeviceIntegrationConnectionSecurity$outboundSchema:
  z.ZodMiniType<
    TestDeviceIntegrationConnectionSecurity$Outbound,
    TestDeviceIntegrationConnectionSecurity
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.optional(z.string()),
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function testDeviceIntegrationConnectionSecurityToJSON(
  testDeviceIntegrationConnectionSecurity:
    TestDeviceIntegrationConnectionSecurity,
): string {
  return JSON.stringify(
    TestDeviceIntegrationConnectionSecurity$outboundSchema.parse(
      testDeviceIntegrationConnectionSecurity,
    ),
  );
}

/** @internal */
export type TestDeviceIntegrationConnectionRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  DeleteConfigRequestBody: DeleteConfigRequestBody$Outbound;
};

/** @internal */
export const TestDeviceIntegrationConnectionRequest$outboundSchema:
  z.ZodMiniType<
    TestDeviceIntegrationConnectionRequest$Outbound,
    TestDeviceIntegrationConnectionRequest
  > = z.pipe(
    z.object({
      gramKey: z.optional(z.string()),
      gramSession: z.optional(z.string()),
      deleteConfigRequestBody: DeleteConfigRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramKey: "Gram-Key",
        gramSession: "Gram-Session",
        deleteConfigRequestBody: "DeleteConfigRequestBody",
      });
    }),
  );

export function testDeviceIntegrationConnectionRequestToJSON(
  testDeviceIntegrationConnectionRequest:
    TestDeviceIntegrationConnectionRequest,
): string {
  return JSON.stringify(
    TestDeviceIntegrationConnectionRequest$outboundSchema.parse(
      testDeviceIntegrationConnectionRequest,
    ),
  );
}
